var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"password-requirements"},_vm._l((_vm.requirementTests),function(requirement){return _c('div',{key:requirement.text,staticClass:"password-requirements__requirements"},[_c('p',{staticClass:"password-requirements__text",class:{
        'password-requirements__text--pass': requirement.test,
        'password-requirements__text--fail': !requirement.test && _vm.showErrors
      },attrs:{"data-gtm":!requirement.test ? 'password-error' : false}},[_vm._v("\n      "+_vm._s(_vm.$t(requirement.text))+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }